import { render } from "./HelpProDialog.vue?vue&type=template&id=18809ead"
import script from "./HelpProDialog.vue?vue&type=script&lang=js"
export * from "./HelpProDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__